import React from 'react'
import PageApp from '../../../Page';
import {Table, Empty, Tag, Button, Modal, Space } from 'antd';
import {getAll} from '../../../../apis/SupervisoresApi';
import { HomeOutlined, UnorderedListOutlined, UserOutlined } from '@ant-design/icons';
import OrganigramaModal from './organigrama';
import UpsertSupervisor from './add';

const SupervisorsPage = () => {
  const [items, setItems] = React.useState([]);
  const [showModal, setShowModal] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [selectedSupervisor, setSelectedSupervisor] = React.useState(null);
  const [editing, setEditing] = React.useState(false);
  const [current, setCurrent] = React.useState(null);

  const onOpenModal = async (item)=>{
    setSelectedSupervisor(item);
    setShowModal(true);
  }

  const closeModal = async ()=> {
    setSelectedSupervisor(null);
    setShowModal(false);
  }

  const openDetails = async (object)=>{
    setOpenEdit(true);
    setSelectedSupervisor(object);
    setCurrent(object);
    setEditing(true);
  }

  const closeEdit = () => {
    setOpenEdit(false);
    setSelectedSupervisor(null);
    setCurrent(null);
    setEditing(false);
  };

  const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Configuración</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Asistencia</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UserOutlined />
        <span>Supervisores</span>
      </>
    ),
  }];
  
  const columns = [
    {
      title: 'Código Corto',
      dataIndex: 'short_code',
      key: 'short_code',
    },
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'Activo',
      dataIndex: 'activo',
      key: 'activo',
      render: (item, object)=>{
        if(object.activo){
          return <Tag color="green">Activo</Tag>
        }
        return <Tag color="red">Inactivo</Tag>
      }
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      render: (item, object)=>{
        return <Space>
            <Button type='primary' size='small' onClick={()=>{
                          openDetails(object);
            }}>Editar</Button>
            <Button type="primary" size='small' onClick={() => onOpenModal(object)}>Organigrama</Button>
          </Space>
      }
    }
  ];

  const effectRan = React.useRef(false);
  React.useEffect(() => {
    if (!effectRan.current) {
      (async () => {
        await refreshData();
      })();
    }
    return () => effectRan.current = true;
  }, []);

  const refreshData = async ()=> {
    const response = await getAll();
    if(response.ok){
      let items = response.payload;
      setItems(items);
    }
  }
  
  return <PageApp routes={routes}>
    <div style={{ marginBottom: 12 }}>
      <UpsertSupervisor onSaved={refreshData} />
    </div>
  {
      items.length == 0 ? <Empty />:
      <Table dataSource={items} 
        columns={columns} 
      />
    }

    {
      selectedSupervisor == null ? null :
      <OrganigramaModal
        open={showModal}
        onClose={closeModal}
        supervisor={selectedSupervisor}
      />
    }

    {openEdit && selectedSupervisor ? (
        <UpsertSupervisor
          mode="edit"
          record={current}
          open={editing}
          onClose={closeEdit}
          onSaved={refreshData}
        />
      ) : null}
  </PageApp>
};

export default SupervisorsPage;